import { ChevronRightSmall } from 'blaze-ui/icons/24'
import Styles from './Carousels.module.scss'
import useButtonWithScrollCancel from 'hooks/useButtonWithScrollCancel'
import { useRef } from 'react'

interface Props {
  title: string
  onPress: () => void
}

export const SectionHeader = ({ title, onPress }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const { buttonProps } = useButtonWithScrollCancel({ onPress, elementType: 'div' }, ref)
  return (
    <div {...buttonProps} className={Styles.sectionHeader} ref={ref}>
      <span className={Styles.title}>{title}</span>
      <ChevronRightSmall />
    </div>
  )
}
